
import { useEffect, useState } from "react";
import "./CompareTwoDateRangeComponent 1.css"
import { DateRangePicker } from "react-date-range";

import {
    addDays,
    endOfDay,
    startOfDay,
    startOfMonth,
    endOfMonth,
    addMonths,
    startOfWeek,
    endOfWeek,
    isSameDay,
    differenceInCalendarDays,
    format,
    isWeekend,
    differenceInDays
} from 'date-fns';
const CompareTwoDateRangeComponent = ({ rangeOne, rangeTwo, apply, minDate, maxDate, setDateToggle }) => {
    const [range, setRange] = useState("rangeOne");
    const [selectionRangeOne, setSelectionRangeOne] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    const [selectionRangeTwo, setSelectionRangeTwo] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    useEffect(() => {
        setSelectionRangeOne({
            startDate: rangeOne.startDate,
            endDate: rangeOne.endDate,
            key: 'selection',
        });
        setSelectionRangeTwo({
            startDate: rangeTwo.startDate,
            endDate: rangeTwo.endDate,
            key: 'selection',
        });
    }, []);



    const handleSelectOne = (ranges) => {
        setSelectionRangeOne(ranges.selection);
    };

    const handleSelectTwo = (ranges) => {
        setSelectionRangeTwo(ranges.selection);
    };

    function customDayContentOne(day) {
        // let extraDot = null;
        // if (isWeekend(day)) {
        //     extraDot = (
        //         <div
        //             style={{
        //                 height: "5px",
        //                 width: "5px",
        //                 borderRadius: "100%",
        //                 background: "orange",
        //                 position: "absolute",
        //                 top: 2,
        //                 right: 2,
        //             }}
        //         />
        //     )
        // }
        return (
            <div>
                {/* {extraDot} */}
                <span style={{
                    color: (() => {
                        if (format(day, 'yyyy-MM-dd') === format(selectionRangeOne.startDate, 'yyyy-MM-dd') || format(day, 'yyyy-MM-dd') === format(selectionRangeOne.endDate, 'yyyy-MM-dd')) {
                            return "white"
                        } else {
                            return "black"
                        }
                    })()
                }}  >{format(day, "d")}</span>
            </div>
        )
    }


    function customDayContentTwo(day) {
        // let extraDot = null;
        // if (isWeekend(day)) {
        //     extraDot = (
        //         <div
        //             style={{
        //                 height: "5px",
        //                 width: "5px",
        //                 borderRadius: "100%",
        //                 background: "orange",
        //                 position: "absolute",
        //                 top: 2,
        //                 right: 2,
        //             }}
        //         />
        //     )
        // }
        return (
            <div>
                {/* {extraDot} */}
                <span style={{
                    color: (() => {
                        if (format(day, 'yyyy-MM-dd') === format(selectionRangeTwo.startDate, 'yyyy-MM-dd') || format(day, 'yyyy-MM-dd') === format(selectionRangeTwo.endDate, 'yyyy-MM-dd')) {
                            return "white"
                        } else {
                            return "black"
                        }
                    })()
                }}  >{format(day, "d")}</span>
            </div>
        )
    }


    const handleApply = () => {
        setDateToggle(false);
        apply({
            rangeOne: {
                startDate: selectionRangeOne.startDate,
                endDate: selectionRangeOne.endDate
            },
            rangeTwo: {
                startDate: selectionRangeTwo.startDate,
                endDate: selectionRangeTwo.endDate
            }
        })
    }

    const defineds = {
        startOfWeek: startOfWeek(new Date()),
        endOfWeek: endOfWeek(new Date()),
        startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
        endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
        startOfToday: startOfDay(new Date()),
        endOfToday: endOfDay(new Date()),
        startOfYesterday: startOfDay(addDays(new Date(), -1)),
        endOfYesterday: endOfDay(addDays(new Date(), -1)),
        startOfMonth: startOfMonth(new Date()),
        endOfMonth: endOfMonth(new Date()),
        startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
        endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
    };

    function createStaticRanges(ranges) {
        return ranges.map(range => ({ ...staticRangeHandler, ...range }));
    }

    const staticRangeHandler = {
        range: {},
        isSelected(range) {
            const definedRange = this.range();
            return (
                isSameDay(range.startDate, definedRange.startDate) &&
                isSameDay(range.endDate, definedRange.endDate)
            );
        },
    };



    const defaultStaticRanges = createStaticRanges(
        [
            {
                label: 'Today',
                range: () => ({
                    startDate: defineds.startOfToday,
                    endDate: defineds.endOfToday,

                }),
            },
            {
                label: 'Yesterday',
                range: () => ({
                    startDate: defineds.startOfYesterday,
                    endDate: defineds.endOfYesterday,

                }),
            },
            {
                label: 'Last 7 days',
                range: () => ({
                    startDate: addDays(new Date(), -7),
                    endDate: addDays(new Date(), -1),

                }),
            },
            {
                label: 'Last 14 days',
                range: () => ({
                    startDate: addDays(new Date(), -14),
                    endDate: addDays(new Date(), -1),

                }),
            },
            {
                label: 'Last 30 days',
                range: () => ({
                    startDate: addDays(new Date(), -30),
                    endDate: addDays(new Date(), -1),

                }),
            },
            {
                label: 'This Week',
                range: () => ({
                    startDate: defineds.startOfWeek,
                    endDate: defineds.endOfWeek,
                }),
            },
            {
                label: 'Last Week',
                range: () => ({
                    startDate: defineds.startOfLastWeek,
                    endDate: defineds.endOfLastWeek,
                }),
            },
            {
                label: 'This Month',
                range: () => ({
                    startDate: defineds.startOfMonth,
                    endDate: defineds.endOfMonth,
                }),
            },
            {
                label: 'Last Month',
                range: () => ({
                    startDate: defineds.startOfLastMonth,
                    endDate: defineds.endOfLastMonth,
                }),
            },

        ]
    );
    return (
        <div style={{ userSelect: "none", display: "flex", flexDirection: "column", paddingTop: 24, paddingBottom: 24, backgroundColor: "white", boxShadow: "0px 4px 16px 6px rgba(130, 130, 130, 0.05)" }} >
            <div style={{ display: "flex", justifyContent: "space-between", paddingLeft: 20, paddingRight: 20, marginBottom: 16, width: "calc(100% - 32px)" }} >
                <div onClick={() => setRange("rangeOne")} style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 8, paddingBottom: 8, border: `1px solid ${range === "rangeOne" ? "#1565C0" : "#EAEAED"}`, borderRadius: 4, display: "flex", alignItems: "center", cursor: "pointer" }}  >
                    <span style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: "#1C1C1E", marginRight: 8, textWrap: "nowrap"}} >{format(selectionRangeOne.startDate, 'dd/MM/yyyy')} - {format(selectionRangeOne.endDate, 'dd/MM/yyyy')}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                        <path d="M14 1.66669V3.33335M4 1.66669V3.33335" stroke="#1C1C1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M1.0835 10.2027C1.0835 6.57161 1.0835 4.75607 2.12693 3.62803C3.17036 2.5 4.84974 2.5 8.2085 2.5H9.79183C13.1506 2.5 14.83 2.5 15.8734 3.62803C16.9168 4.75607 16.9168 6.57161 16.9168 10.2027V10.6306C16.9168 14.2617 16.9168 16.0773 15.8734 17.2053C14.83 18.3333 13.1506 18.3333 9.79183 18.3333H8.2085C4.84974 18.3333 3.17036 18.3333 2.12693 17.2053C1.0835 16.0773 1.0835 14.2617 1.0835 10.6306V10.2027Z" stroke="#1C1C1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M1.5 6.66669H16.5" stroke="#1C1C1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div onClick={() => setRange("rangeTwo")} style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 8, paddingBottom: 8, border: `1px solid ${range === "rangeTwo" ? "#1565C0" : "#EAEAED"}`, borderRadius: 4, display: "flex", alignItems: "center", cursor: "pointer" }}  >
                    <span style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: "#1C1C1E", marginRight: 8, textWrap: "nowrap" }} >{format(selectionRangeTwo.startDate, 'dd/MM/yyyy')} - {format(selectionRangeTwo.endDate, 'dd/MM/yyyy')}</span>

                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                        <path d="M14 1.66669V3.33335M4 1.66669V3.33335" stroke="#1C1C1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M1.0835 10.2027C1.0835 6.57161 1.0835 4.75607 2.12693 3.62803C3.17036 2.5 4.84974 2.5 8.2085 2.5H9.79183C13.1506 2.5 14.83 2.5 15.8734 3.62803C16.9168 4.75607 16.9168 6.57161 16.9168 10.2027V10.6306C16.9168 14.2617 16.9168 16.0773 15.8734 17.2053C14.83 18.3333 13.1506 18.3333 9.79183 18.3333H8.2085C4.84974 18.3333 3.17036 18.3333 2.12693 17.2053C1.0835 16.0773 1.0835 14.2617 1.0835 10.6306V10.2027Z" stroke="#1C1C1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M1.5 6.66669H16.5" stroke="#1C1C1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
            </div>
            <div style={{}} >
                {
                    range === "rangeOne" && (
                        <DateRangePicker
                            ranges={[selectionRangeOne]}
                            onChange={handleSelectOne}
                            minDate={minDate}
                            maxDate={maxDate}
                            // months={2}
                            // direction='horizontal'
                            inputRanges={[]}
                            staticRanges={defaultStaticRanges}
                            dayContentRenderer={customDayContentOne}

                        />
                    )
                }
                {
                    range === "rangeTwo" && (
                        <DateRangePicker
                            ranges={[selectionRangeTwo]}
                            onChange={handleSelectTwo}
                            minDate={minDate}
                            maxDate={maxDate}
                            // months={2}
                            // direction='horizontal'
                            inputRanges={[]}
                            staticRanges={defaultStaticRanges}
                            dayContentRenderer={customDayContentTwo}
                        />
                    )
                }
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }} >
                <div style={{ display: "flex", justifyContent: "space-between", width: 352, borderLeft: "1px solid rgb(239, 242, 247)" }} >
                    <div style={{ marginLeft: 16 }}>
                        <div style={{ color: "#97979A", fontSize: 12, letterSpacing: 1.6 }} >SELECTED DAYS</div>
                        <div style={{ fontSize: 14, fontWeight: 600, lineHeight: "20px", marginTop: 8 }} >
                            {
                                range === "rangeOne" && <> {format(selectionRangeOne?.startDate, 'dd/MM/yyyy')} - {format(selectionRangeOne?.endDate, 'dd/MM/yyyy')}</>
                            }
                            {
                                range === "rangeTwo" && <> {format(selectionRangeTwo?.startDate, 'dd/MM/yyyy')} - {format(selectionRangeTwo?.endDate, 'dd/MM/yyyy')}</>
                            }

                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", marginRight: 16 }} >
                        <div style={{ color: "#97979A", fontSize: 12, letterSpacing: 1.6 }} >DAYS</div>
                        {
                            range === "rangeOne" && <><div style={{ fontSize: 14, fontWeight: 600, lineHeight: "20px", marginTop: 8 }} > {differenceInDays(selectionRangeOne.endDate, selectionRangeOne.startDate) + 1} DAYS</div></>
                        }
                        {
                            range === "rangeTwo" && <><div style={{ fontSize: 14, fontWeight: 600, lineHeight: "20px", marginTop: 8 }} > {differenceInDays(selectionRangeTwo.endDate, selectionRangeTwo.startDate) + 1} DAYS</div></>
                        }

                    </div>
                </div>

                <div style={{ width: 352, marginTop: 24 }} >

                    <div style={{ display: "flex", justifyContent: "space-between", marginLeft: 16, marginRight: 16 }} >
                        <div style={{
                            display: "flex", alignItems: "center", justifyContent: "center", height: 32, width: 136, borderRadius: 4,
                            border: "1px solid #EAEAED",
                            fontSize: 12, fontStyle: "normal", fontWeight: 700, lineHeight: "18px",
                            cursor: "pointer"
                        }} 
                        onClick={() => setDateToggle(false)}>
                            Cancel
                        </div>
                        <div style={{
                            display: "flex", alignItems: "center", justifyContent: "center", height: 32, width: 136, borderRadius: 4,
                            border: "1px solid #1565C0",
                            backgroundColor: "#1565C0",
                            color: "white",
                            cursor: "pointer",
                            fontSize: 12, fontStyle: "normal", fontWeight: 700, lineHeight: "18px",

                        }}
                            onClick={handleApply}
                        >
                            Apply
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CompareTwoDateRangeComponent;